import * as React from 'react';
import styles from './SharePointOrganizer.module.scss';
import type { IScanResult } from '../../../models/ScanResult';
import { formatBytes, formatDuration, formatNumber } from '../../../utils/format';

export interface IScanSummaryProps {
  result: IScanResult;
}

interface IStat {
  label: string;
  value: string;
}

export default function ScanSummary(props: IScanSummaryProps): React.ReactElement {
  const { result } = props;
  const stats: IStat[] = [
    { label: 'Files', value: formatNumber(result.fileCount) },
    { label: 'Folders', value: formatNumber(result.folderCount) },
    { label: 'Total size', value: formatBytes(result.totalSize) },
    { label: 'Deepest level', value: formatNumber(result.maxDepth) },
    { label: 'Scan time', value: formatDuration(result.durationMs) }
  ];

  return (
    <div className={styles.summary}>
      <h3 className={styles.sectionTitle}>{result.library.name}</h3>
      <div className={styles.stats}>
        {stats.map(s => (
          <div key={s.label} className={styles.stat}>
            <div className={styles.statLabel}>{s.label}</div>
            <div className={styles.statValue}>{s.value}</div>
          </div>
        ))}
      </div>
      {Object.keys(result.protectedFolders).length > 0 && (
        <p className={styles.issueListDescription}>
          {formatNumber(Object.keys(result.protectedFolders).length)} {Object.keys(result.protectedFolders).length === 1 ? 'folder is' : 'folders are'} used
          by Microsoft Teams channels and will never be moved, renamed or removed.
        </p>
      )}
      {result.managedItemCount > 0 && (
        <p className={styles.issueListDescription}>
          {formatNumber(result.managedItemCount)} {result.managedItemCount === 1 ? 'file is' : 'files are'} in _Quarantine and not included in this report.
        </p>
      )}
    </div>
  );
}
